<form class="flex-col flex-fill" #form="ngForm" style="position: relative; max-width: 280px">
    <button
        mat-mini-fab
        color="accent"
        class="collapse-button"
        (click)="collapsed$.next(!collapsed$.value)"
        [matTooltip]="collapsed$.value ? 'Expand' : 'Collapse'"
    >
        <mat-icon>
            {{ collapsed$.value ? 'chevron_left' : 'chevron_right ' }}
        </mat-icon>
    </button>
    <mat-card class="collapsible-card flex-col">
        <mat-card-content>
            @if (collapsed$ | async) {
                <div class="flex-row">
                    <h1 class="mat-headline-6 collapsed-title">Project Information</h1>
                </div>
            }
            @if (!(collapsed$ | async)) {
                <div class="flex-col flex">
                    <h4 class="mat-headline-6">{{ mappedItem.code }}</h4>
                    <h4 class="mat-subtitle-2 cb-margin-bottom-nil">
                        {{ mappedItem.projectName }}
                    </h4>
                    <div style="position: relative" class="cb-margin-bottom-2x">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="flex-row flex">
                        <span class="flex"></span>
                        <button [matMenuTriggerFor]="menu" mat-icon-button>
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="uploadImage()">
                                <mat-icon>file_upload</mat-icon>
                                &nbsp; Upload Logo
                            </button>
                            @if (showDeleteButton) {
                                <button mat-menu-item (click)="deleteImage()">
                                    <mat-icon>delete</mat-icon>
                                    &nbsp; Delete Logo
                                </button>
                            }
                        </mat-menu>
                    </div>
                    <cb-image-button
                        class="flex"
                        [baseUrl]="mappedItem.projectLogoUrl"
                        [height]="200"
                        [width]="400"
                    >
                    </cb-image-button>
                    <cb-display-value-new label="Lot" [value]="mappedItem.lot">
                    </cb-display-value-new>
                    <cb-address-new
                        [(ngModel)]="mappedItem.address"
                        [readonly]="true"
                        name="address"
                        class="cb-margin-bottom-2x"
                    >
                    </cb-address-new>
                    <cb-display-value-new
                        label="Account Owner"
                        [value]="mappedItem.accountOwner.label"
                    >
                    </cb-display-value-new>
                    @if (projectPermissions.canEdit()) {
                        <button
                            mat-raised-button
                            class="cb-margin-bottom-2x"
                            color="primary"
                            (cbClick)="editProject()"
                            [disabled]="!mappedItem.canEdit()"
                        >
                            Edit Project
                        </button>
                    }
                    @if (projectPermissions.canComplete()) {
                        <button
                            mat-raised-button
                            color="primary"
                            class="cb-margin-bottom-2x"
                            (cbClick)="completeProject()"
                            [disabled]="!mappedItem.canComplete()"
                        >
                            Complete Project
                        </button>
                    }
                    @if (projectPermissions.canCancel()) {
                        <button
                            mat-raised-button
                            color="primary"
                            class="cb-margin-bottom-2x"
                            (cbClick)="cancelProject()"
                            [disabled]="!mappedItem.canCancel()"
                        >
                            Cancel Project
                        </button>
                    }
                    @if (mappedItem.createdDate && mappedItem.createdByName) {
                        <cb-user-date-time-new
                            label="Created"
                            [displayTime]="true"
                            [date]="mappedItem.createdDate"
                            [userFullName]="mappedItem.createdByName"
                            [floatingLabel]="true"
                        >
                        </cb-user-date-time-new>
                    }
                    @if (mappedItem.updatedDate && mappedItem.updatedByName) {
                        <cb-user-date-time-new
                            label="Updated"
                            [displayTime]="true"
                            [date]="mappedItem.updatedDate"
                            [userFullName]="mappedItem.updatedByName"
                            [floatingLabel]="true"
                        >
                        </cb-user-date-time-new>
                    }
                </div>
            }
        </mat-card-content>
    </mat-card>
</form>
